import React from "react";
import BreadCrumbComp from "../../components/breadCrumb";
import { Grid, useMediaQuery } from "@mui/material";
import LaddaButton from "../../components/buttons/laddaButton";
import { icons } from "../../constants";
import { useNavigate } from "react-router-dom";
import { pieChard } from "../../components/highchartsComponent/charts/pieChard";
import HighchartsComponent from "../../components/highchartsComponent";
import { useSelector } from "react-redux";
import { callApiAsync, getPilarSuppliersGraph } from "../../services/apiService";
import { useEffect } from "react";
import { useState } from "react";

const Suppliers = () => {
  const [graphData, setGraphData] = useState([])
  const navigate = useNavigate();
  const userData = useSelector((state) => state.userData.userData);

  const isSmallScreen = useMediaQuery("(max-width:590px)");
  const isMediumScreen = useMediaQuery("(max-width:900px)");

  const getGraphData = async () => {
    await callApiAsync(
      () => getPilarSuppliersGraph(),
      (data) => {
        setGraphData(data);
      }
    );
    return;
  };

  let buttonHeight = "60px";

  const customFormatter = function () {
    const color = this.point.color;
    return `
    <span style="color:${color}; font-weight: bold;">
      ${this.point.name} :
    </span> 
    <span style="font-weight: bold;">${this.y}</span>
  `;
  };

  const customTooltip = {
    formatter: customFormatter,
    useHTML: true
  };

  if (isMediumScreen) {
    buttonHeight = "40px";
  } else if (isSmallScreen) {
    buttonHeight = "35px";
  }

  useEffect(() => {
    getGraphData();
  }, []);

  return (
    <div>
      <BreadCrumbComp />
      <div className="searchTitle">
        <h1>DASHBOARD PROVEEDORES</h1>
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={4}>
          <LaddaButton
            variant="contained"
            onClick={() => {
              navigate("/suppliers/suppliers_national", {
                state: { type: "maintenance", data: {} }
              });
            }}
            height={buttonHeight}
            borderRadius={"15px"}
            width={"100%"}
          >
            <div className="IHContainer align-center">
              <img
                className="btn-icon"
                src={icons.pcMonitor}
                alt="icon"
                style={{ marginRight: "10px" }}
              />
              <p className="button_text">Proveedor Farmacéutico Nacional</p>
            </div>
          </LaddaButton>
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <LaddaButton
            variant="contained"
            color={"#404040"}
            backgroundColor={"#F4D658"}
            onClick={() => {
              navigate("/suppliers/international_suppliers", {
                state: { type: "maintenance", data: {} }
              });
            }}
            width={"100%"}
            borderRadius={"15px"}
            height={buttonHeight}
          >
            <div className="IHContainer align-center">
              <img
                className="btn-icon"
                src={icons.verificationList}
                alt="icon"
                style={{ marginRight: "10px" }}
              />
              <p className="button_text">
                Proovedor Farmacéutico Internacional
              </p>
            </div>
          </LaddaButton>
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <LaddaButton
            variant="contained"
            onClick={() => {
              navigate("/suppliers/services_suppliers", {
                state: { type: "maintenance", data: {} }
              });
            }}
            height={buttonHeight}
            borderRadius={"15px"}
            width={"100%"}
          >
            <div className="IHContainer align-center">
              <img
                className="btn-icon"
                src={icons.contract}
                alt="icon"
                style={{ marginRight: "10px" }}
              />
              <p className="button_text">Proveedor de Servicios</p>
            </div>
          </LaddaButton>
        </Grid>
      </Grid>

      <div className="table-container">
        <h1 className="title-bio-details-chard">
          CLASIFICACIÓN DE PROVEEDORES
        </h1>

        <HighchartsComponent
          options={pieChard("", "", graphData, [], customTooltip)}
        />
      </div>
    </div>
  );
};

export default Suppliers;
